import { DEFAULT_TOR_RULE, DEFAULT_TOR_RULES_FORM } from "./constants";
import type { TorRuleFormItem, TorRulesFormValues, TorRulesHydrationSource } from "./types";

const mapTorRuleToFormItem = (rule: Partial<TorRuleFormItem>): TorRuleFormItem => ({
  torPercent: Number(rule.torPercent ?? DEFAULT_TOR_RULE.torPercent),
  minSale: Number(rule.minSale ?? DEFAULT_TOR_RULE.minSale),
  maxSale: Number(rule.maxSale ?? DEFAULT_TOR_RULE.maxSale),
  minLimit: Number(rule.minLimit ?? DEFAULT_TOR_RULE.minLimit),
  uptoLimit: Number(rule.uptoLimit ?? DEFAULT_TOR_RULE.uptoLimit),
});

export const mapTorRulesToFormItems = (
  rules?: TorRulesHydrationSource["torRules"],
): TorRuleFormItem[] => {
  if (!rules?.length) return [DEFAULT_TOR_RULE];
  return rules.map(({ torRuleCondition: _ignored, ...rest }) => mapTorRuleToFormItem(rest));
};

export const mapSourceToTorRulesFormValues = (source?: TorRulesHydrationSource): TorRulesFormValues => {
  if (!source?.torRules?.length) return DEFAULT_TOR_RULES_FORM;

  const torRuleCondition =
    source.torRuleCondition === "and" || source.torRuleCondition === "or"
      ? source.torRuleCondition
      : DEFAULT_TOR_RULES_FORM.torRuleCondition;

  return {
    torRuleCondition,
    torRules: mapTorRulesToFormItems(source.torRules),
  };
};
